import {loading, stopLoading} from "../../helpers/loading";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";
import {initVoeThirdPartyCompanyForm} from "./form";
import Axios from "axios";

function initVoeThirdPartyCompaniesEdit() {
	const companyForm = initVoeThirdPartyCompanyForm(document.querySelector('.third-party-companies-form'));

	document.querySelector('.update-third-party-companies-button').onclick = updateVoeThirdPartyCompany;

	function updateVoeThirdPartyCompany() {
		const companyData = companyForm.inputs();

		companyForm.clearFeedbacks();

		loading();

		Axios.post(companyForm.postRoute(), companyData)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)
	}
}

export {initVoeThirdPartyCompaniesEdit}
